export interface PlantSource {
  id: string;
  name: string;
  type: PlantSourceType;
  website?: string | null;
  location?: string | null;
  qrCodeId?: string | null;
  createdAt: string;
  updatedAt: string;
  createdBy: string;
  creator?: {
    id: string;
    name?: string | null;
    email?: string;
  };
  _count?: {
    plants: number;
  };
  plants?: Array<{
    id: string;
    displayName: string;
    variety?: {
      primaryCommonName: string;
      species: {
        name: string;
        genus: {
          name: string;
        };
      };
    } | null;
  }>;
}

export type PlantSourceType =
  | 'NURSERY'
  | 'SEED_COMPANY'
  | 'ONLINE_RETAILER'
  | 'LOCAL_GARDEN_CENTER'
  | 'PERSONAL_COLLECTION'
  | 'OTHER';

export const PLANT_SOURCE_TYPES: Record<PlantSourceType, string> = {
  NURSERY: 'Nursery',
  SEED_COMPANY: 'Seed Company',
  ONLINE_RETAILER: 'Online Retailer',
  LOCAL_GARDEN_CENTER: 'Garden Center',
  PERSONAL_COLLECTION: 'Personal Collection',
  OTHER: 'Other',
};

export interface CreatePlantSourceInput {
  name: string;
  type: PlantSourceType;
  website?: string | null;
  location?: string | null;
}

export interface UpdatePlantSourceInput {
  name?: string;
  type?: PlantSourceType;
  website?: string | null;
  location?: string | null;
}

export type PlantSourceScope = 'public' | 'user' | 'all';

export interface PlantSourceSearchParams {
  search?: string;
  type?: PlantSourceType;
  scope?: PlantSourceScope;
  userId?: string;
  sortBy?: 'created_at' | 'name' | 'type';
  sortOrder?: 'asc' | 'desc';
  limit?: number;
  offset?: number;
}

export interface PlantSourceListResponse {
  sources: PlantSource[];
  pagination: {
    total: number;
    limit: number;
    offset: number;
  };
}

export interface PlantSourceQRCodeResponse {
  qrCodeId: string;
  qrCodeUrl: string;
  qrCodeDataUrl: string;
}

export interface PublicPlantSourceView {
  source: PlantSource;
  _count: {
    plants: number;
  };
}
